module.exports = __webpack_public_path__ + "static/img/cha2.ea9bb07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/cha2.png
// module id = 0YeR
// module chunks = 1